import { Text } from '@mantine/core'
import React from 'react'

const PageTitle = ({ title }) => {
    return (
        <Text style={{ textAlign: "center" }} size="md" weight={700} m="sm">{title}</Text>
    )
}

export default PageTitle
